import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ArrowLeft, LogOut } from "lucide-react";
import Settings from "@/pages/dashboard/Settings";

/**
 * Settings page wrapped in a minimal header for roles that don't use the
 * shared DashboardLayout sidebar — currently the Publisher dashboard.
 */
export default function StandaloneSettings() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50/40">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/publisher" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900" data-testid="settings-back">
            <ArrowLeft className="size-3.5" /> Back to dashboard
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-[12.5px] text-slate-500 hidden sm:inline">{user?.email}</span>
            <Button variant="ghost" size="sm" onClick={() => { logout(); nav("/"); }} className="rounded-full" data-testid="settings-logout">
              <LogOut className="size-4" /> Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-8">
        <Settings />
      </main>
    </div>
  );
}
